module.exports = __webpack_public_path__ + "img/wtb4.9f23d433.png";